<div class="upload-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      {{ dataType }} Image
      <span class="item-name">{{ image.cloverDataName }}</span>
    </h2>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <mat-error *ngIf="selectionError" class="error-msg">{{ errorMsg }}</mat-error>

    <!-- Image preview / upload zone -->
    <div class="image-upload-zone"
         [class.has-image]="imagePreviewUrl"
         [class.dragging]="isDragging"
         (click)="selectImage.click()"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
      <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl" class="image-preview" alt="Preview">
      <div *ngIf="!imagePreviewUrl" class="upload-placeholder">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <span class="upload-text">Drop image here or click to upload</span>
        <span class="upload-hint">PNG, JPG up to 5MB</span>
      </div>
      <div *ngIf="imagePreviewUrl" class="image-overlay">
        <mat-icon>edit</mat-icon>
        <span>Change image</span>
      </div>
    </div>
    <input #selectImage type="file" hidden name="myfile" id="myFile" accept="image/*" (change)="onSelect()">

    <div class="url-section">
      <div class="divider-text"><span>or paste a URL</span></div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Image URL</mat-label>
        <input matInput type="url" id="image-url" placeholder="https://...">
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button class="delete-btn" [disabled]="submitted" (click)="currentUser.orgSettings.accountType === Constants.SQUARE ? deleteSquare() : delete()">
      <mat-icon>delete_outline</mat-icon> Delete Image
    </button>
    <span class="spacer"></span>
    <button mat-button class="cancel-btn" (click)="close()">Cancel</button>
    <button mat-raised-button class="save-btn" [disabled]="submitted"
            (click)="currentUser.orgSettings.accountType === Constants.SQUARE ? saveSquare() : save()">
      {{ submitted ? 'Saving...' : 'Update Image' }}
    </button>
  </mat-dialog-actions>
</div>
